import { engineComponent } from "neo-common";
import { HtmlController } from "../HtmlController";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { HtmlContainerElement } from "./HtmlContainerElement";
import { AppContext } from "../../../Common/AppContext";
import { DataManager } from "../../Managers/DataManager";

/**
 *
 * @class HtmlCustomContainerElement
 * @extends HtmlContainerElement
 */
@engineComponent(ComponentTypes.HtmlElement)
export class HtmlCustomContainerElement extends HtmlContainerElement {
    private _withGamble: HTMLElement;
    private _withoutGamble: HTMLElement;

    constructor() {
        super();
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @return void
     */
    create(node: Element): void {
        super.create(node);
    }

    changeState(value: boolean): void {
        if (this._withGamble == null) {
            this._withGamble = document.getElementById("withGamble");
        }
        if (this._withoutGamble == null) {
            this._withoutGamble = document.getElementById("withoutGamble");
        }

        if (this.instance != null) {
            if (value && DataManager.Autoplay) {
                this.instance.classList.remove(HtmlController.DisabledClass);
                if (AppContext.gameDefinition.Gamble) {
                    if (this._withGamble != null) {
                        this._withGamble.style.display = "block";
                    }
                    if (this._withoutGamble != null) {
                        this._withoutGamble.style.display = "none";
                    }
                } else {
                    if (this._withGamble != null) {
                        this._withGamble.style.display = "none";
                    }
                    if (this._withoutGamble != null) {
                        this._withoutGamble.style.display = "block";
                    }
                }
            } else {
                if (!this.instance.classList.contains(HtmlController.DisabledClass)) {
                    this.instance.classList.add(HtmlController.DisabledClass);
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no instance");
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Elements/HtmlCustomContainerElement.ts
 **/